export * from './Text'
export type { TextProps } from './Text.types'
